import React from 'react';
import styled from 'styled-components';
import { StaticImage } from 'gatsby-plugin-image';
import { StrapiTextual } from '@/features/strapi/components/textual';

export function BuiltForShopify() {
  return (
    <Wrapper className="built-for-shopify">
      <StrapiTextual text="Built for" size="1.35rem" mobileMultiplier={0.9} />
      <StaticImage
        className="only-desktop"
        src="smallshopify.png"
        alt="Built for Shopify"
        width={60}
        quality={100}
        placeholder="none"
      />
      <StaticImage
        className="only-mobile"
        src="smallshopify.png"
        alt="Built for Shopify"
        width={70}
        quality={100}
        placeholder="none"
      />
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  grid-gap: 1rem;
  padding: 0.5rem 1.5rem;
  align-items: center;
  justify-content: center;
  background: rgba(243, 236, 229, 0.7);
  border-radius: 3rem;
  width: fit-content;
  align-self: center;

  letter-spacing: -0.5px;
`;
